const getSolutionsFeatures = (variant, getLabel)=>{
    const productFeatures = [
        {
            labelKey: 'products.solutions.lensTypeTarget',
            attribute: 'lensTypeTarget',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.caseIncluded',
            attribute: 'caseIncluded'
        },
        {
            labelKey: 'products.solutions.minimumCycleTime',
            attribute: 'minimumCycleTime',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.preservativeFree',
            attribute: 'preservativeFree'
        },
        {
            labelKey: 'products.solutions.maxTimeFrameInLensCase',
            attribute: 'maxTimeFrameInLensCase',
            isLocalised: true
        },
        {
            labelKey: 'products.solutions.expirationAfterOpening',
            attribute: 'expirationAfterOpening',
            isLocalised: true
        }, 
    ];
    const disinfect = {
        label: getLabel('products.solutions.features.cbDisinfect'),
        variantHasAttribute: !!variant.features.disinfect
    };
    const hydration = {
        label: getLabel('products.solutions.features.cbHydration'),
        variantHasAttribute: !!variant.features.hydration
    };
    const comfort = {
        label: getLabel('products.solutions.features.cbComfort'),
        variantHasAttribute: !!variant.features.comfort
    };
    const cleaning = {
        label: getLabel('products.solutions.features.cbCleaning'),
        variantHasAttribute: !!variant.features.cleaning
    };
    const sensitivity = {
        label: getLabel('products.solutions.features.cbSensitivity'),
        variantHasAttribute: !!variant.features.sensitivity
    };
    const rinsing = {
        label: getLabel('products.solutions.features.cbRinsing'),
        variantHasAttribute: !!variant.features.rinsing
    };
    const solutionsFeatures = {
        disinfect,
        hydration,
        comfort,
        cleaning,
        sensitivity,
        rinsing
    };
    return {
        productFeatures,
        solutionsFeatures
    };
};

export { getSolutionsFeatures };
//# sourceMappingURL=get-solutions-features.js.map
